import { createContext } from 'react';
import firebase from '../Firebase';

export const FirebaseContext = createContext(firebase);
export const FirebaseUserContext = createContext(null);
